import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { toggleSMLPricingModal } from '../../../redux/slices/appInfo/slice';

/** Opens the plan picker, the same window the old trial banner opened. */
export function useOpenPlans(): () => void {
  const dispatch = useDispatch();
  return useCallback(() => {
    dispatch(toggleSMLPricingModal({ shouldShow: true }));
  }, [dispatch]);
}
